<mat-form-field
  [formGroup]="form"
  appearance="outline"
  class="wideInput"
  [ngClass]="{ 
    'error-border': containErrors || countError || invalidParenthesisError,
    'error-margin': invalidParenthesisError
  }">

  <mat-label
    [ngClass]="{ 'error-text': containErrors || countError || invalidParenthesisError}">
    {{this.ctrl.label}}{{this.ctrl.required === true ? '*' : ''}}
  </mat-label>

  <mat-chip-grid
    #chipGrid
    aria-label="Result selection">

    <mat-chip-row
      *ngFor="let option of selectedOptions"
      (removed)="remove(option)">
          
      <span
        class="truncate">
        @if (option.id === option.value) {
          {{ option.id }}
        } @else {
          {{option.value}}
        }
      </span>

      <button matChipRemove>
        <mat-icon>
          cancel
        </mat-icon>
      </button>
    </mat-chip-row>
  </mat-chip-grid>
  <div class="input-container">
  <input
    matInput
    placeholder="Start typing..."
    #searchInput
    [formControl]="searchCtrl"
    [matChipInputFor]="chipGrid"
    [matAutocomplete]="auto"
    (blur)="onBlur()"
    (keydown.enter)="selected()"
    />

    @if (isLoading) {
      <svg 
        aria-hidden="true"
        class="searchIcon loader"
        xmlns="http://www.w3.org/2000/svg"
        height="24"
        viewBox="0 -960 960 960"
        width="24">
        <path d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q17 0 28.5 11.5T520-840q0 17-11.5 28.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-17 11.5-28.5T840-520q17 0 28.5 11.5T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Z"/>
      </svg>
    }
    @else if (!isLoading) {
      <mat-icon class="searchIcon">
        search
      </mat-icon>
    }
  </div>
        
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="selected($event)">

    <mat-option
      *ngFor="let option of filteredOptions | async"
      [value]="option" 
      class="searchedValue">
      {{ option.value }}
    </mat-option>
  </mat-autocomplete>

  <mat-hint 
    *ngIf="containErrors || countError || invalidParenthesisError" 
    [ngClass]="{ 'error-text': true }">
    {{ errorText() }}
  </mat-hint>

</mat-form-field>